import { gql } from '@apollo/client';

import { NutritionFragmentDoc } from 'generated/sanity-graphql';

import { itemOption } from './item-option';
import { menuImage } from './menu-image';
import { vendorConfigs } from './vendor-configs';

export const item = gql`
  fragment ItemFragment on Item {
    _id
    _type
    name {
      locale: _LANG_
    }
    image {
      ...MenuImageFragment
    }
    rewardEligible
    isDummyItem
    labelAsPerPerson
    operationalItem {
      daypart
    }
    vendorConfigs {
      ...VendorConfigsFragment
    }
    nutrition {
      ...NutritionFragment
    }
    nutritionWithModifiers {
      ...NutritionFragment
    }
    options {
      ...ItemOptionFragment
    }
    productHierarchy {
      L1
      L2
      L3
      L4
      L5
    }
  }

  ${menuImage}
  ${itemOption}
  ${vendorConfigs}
  ${NutritionFragmentDoc}
`;
